const PSState = require('PSState');
const AudioMap = require('AudioMap');
const OverlayMax = { opacity: 200 };
const OverlayMin = { opacity: 0 };
const scaleUp = { scale: 1.4 };
const scaleDown = { scale: 1 };
const BlockTo = { x: 0, y: 0 };
const SineInOut = { easing: 'sineInOut' };

cc.Class({
    extends: cc.Component,

    properties: {
        spine: sp.Skeleton,
        mainSkin: 'osnova',
        fsSkin: 'freespins',
        overlay: cc.Node,
        topLayer: cc.Node,
    },

    onLoad () {
        this.audioMap = cc.find('AudioMap').getComponent(AudioMap);
        this.overlay.active = false;
        this.bones = [
            this.spine.findBone('X1'),
            this.spine.findBone('X2'),
            this.spine.findBone('X3'),
        ]
    },

    setMain () {
        this.spine.setSkin(this.mainSkin);
    },

    setFs () {
        this.spine.setSkin(this.fsSkin);
    },


    set (progressPerBet) {
        const progress = this._getValue(progressPerBet);
        if (this.progress === progress) {
            return;
        }
        this.progress = progress;

        this.spine.setAnimation(0, `idle${this.progress}`, true);
    },

    prepareForShot () {
        switch(this.progress) {
            case 3:
                this.spine.setAnimation(0, 'farting', true);
                break;
            case 4:
                this.spine.setAnimation(0, 'farting1', true);
                break;
            case 5:
                this.spine.setAnimation(0, 'farting2', true);
                break;
            case 6:
                this.spine.setAnimation(0, 'farting3', true);
                break;
        }
    },

    shot (blocks, progressPerBet) {

        blocks.forEach((block, i) => {
            this.audioMap.playSfx('specialWildReleaseFromCollector');

            this.scheduleOnce(() => {
                const blockIndex = i + 1;
                this.audioMap.playSfx('wildTransform' + blockIndex);
            }, 0.4 * i + 1);
            const pos = this.spine.node.parent.convertToNodeSpaceAR(block.getWorldCoord());
            this.bones[i].x = pos.x / this.spine.node.scale;
            this.bones[i].y = pos.y / this.spine.node.scale;
        });

        this.spine.setEventListener((_track, event) => {
            switch(event.data.name) {
                case 'shot1':
                    blocks[0].overrideToWild(this.progress, 3);
                    break;
                case 'shot2':
                    blocks[1].overrideToWild(this.progress, 2);
                    break;
                case 'shot3':
                    blocks[2].overrideToWild(this.progress, 1);
                    break;
            }
        });

        // const progress = this._getValue(progressPerBet);
        // this.progress -= progress;
        this.progress -= 3;
        let shotAnim = 1;

        switch(this.progress) {
            case 0:
                shotAnim = 1;
                break;
            case 1:
                shotAnim = 4;
                break;
            case 2:
                shotAnim = 3;
                break;
            case 3:
                shotAnim = 2;
                break;
        }

        this.spine.setAnimation(0, `shot${shotAnim}`, false);
        this.spine.addAnimation(0, `idle${this.progress}`, true);
    },


    match (block) {
        this.overlay.active = true;
        this.overlay.opacity = 0;
        this.topLayer.scale = 1;
        cc.tween(this.overlay).to(0.5, OverlayMax).start();

        const bNode = block.node;
        bNode.setParentKeepPosition(this.topLayer);
        const bFrom = { x: bNode.x, y: bNode.y };

        cc.tween(this.topLayer).to(0.3, scaleUp).start();
        cc.tween(bNode).to(0.3, BlockTo, SineInOut).call(() => {
        }).start();
        block.playThunder();

        this.progress = Math.min((this.progress + 1), 6);
        this.scheduleOnce(() => {
            this.audioMap.playSfx('wildShoot');
        }, .5);

        this.spine.setAnimation(0, `match${this.progress}`, false);
        this.spine.addAnimation(0, `idle${this.progress}`, true);

        this.scheduleOnce(() => {
            cc.tween(this.overlay).to(0.2, OverlayMin).start();
            cc.tween(this.topLayer).to(0.15, scaleDown, SineInOut).start();
            cc.tween(bNode).to(0.2, bFrom, SineInOut).call(() => {
                bNode.setParentKeepPosition(block.symbolContainer);
                block.stopThunder();
                this.overlay.active = false;
            }).start();
        }, 1.4);

        return new Promise(resolve => this.scheduleOnce(resolve, 1.8));
    },

    consume () {
        this.progress --;
        this.spine.setAnimation(0, `end${3 - this.progress}`, false);
    },

    fill () {
        this.progress = 3;

        this.spine.setAnimation(0, `match${this.progress}`, false);
        this.spine.addAnimation(0, `idle${this.progress}`, true);
    },

    _getValue (progressPerBet) {
        const { value } = progressPerBet;
        return value.hasOwnProperty(PSState.betAmount) ? value[PSState.betAmount] : 0;
    }

});
